import { render } from "./ManicuristasCRUD.vue?vue&type=template&id=1ce36d92&scoped=true"
import script from "./ManicuristasCRUD.vue?vue&type=script&lang=js"
export * from "./ManicuristasCRUD.vue?vue&type=script&lang=js"

import "./ManicuristasCRUD.vue?vue&type=style&index=0&id=1ce36d92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce36d92"]])

export default __exports__